/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

// System Defined variables
import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import MoreVert from '@material-ui/icons/MoreVert'
import Fade from '@material-ui/core/Fade'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import { useRecoilValue } from 'recoil'

// Custom Defined variables
import EditIcon from '../../../../../src/assets/images/EditIcon.svg'
import DeleteIcon from '../../../../../src/assets/images/DeleteIcon.svg'
import PreviewIcon from '../../../../../src/assets/static/preview.svg'
import ApproveIcon from '../../../../../src/assets/static/approveIcon.svg'
import ReRunIcon from '../../../../../src/assets/static/reRunIcon.svg'
import PCNDownloadIcon from '../../../../../src/assets/static/pcndownloadicon.svg'
import SendEmailIcon from '../../../../../src/assets/static/sendemailicon.svg'
import EyePreviewIcon from '../../../../../src/assets/static/eyePreviewIcon.svg'
import CloneIcon from '../../../../../src/assets/static/cloneIcon.svg'
import LibraryAddCheck from '../../../../../src/assets/static/libraryAddCheck.svg'
import EditIconAira from '../../../../../src/assets/static/editIconAira.svg'
import DeleteAIRA from '../../../../../src/assets/static/deleteAIRA.svg'
import EyeIcon from '../../../../../src/assets/static/eyeIcon.svg'
import CrossCancelIcon from '../../../../../src/assets/static/CrossCancelIcon.svg'
import ViewEyeBlackIcon from '../../../../../src/assets/static/View_eye_black.svg'
import RejectRedIcon from '../../../../../src/assets/static/Reject_red.svg'
import ThumbDownIcon from '../../../../../src/assets/static/thumb_down.svg'
import ThumbUpIcon from '../../../../../src/assets/static/thumb_up.svg'

import './MoreVertIcon.css'
import utils from '../../../../utils/utils'
import {
  mappedUserRoles,
  selectedContractDetails,
  contractDetailsAtom,
} from '../../recoil/atoms/atoms'

const MoreVertIcon = ({
  row,
  data,
  RowActions,
  rowIndex,
  className,
  disabled,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(false)
  const selectedContract = useRecoilValue(selectedContractDetails)
  const contractType = selectedContract?.contractType?.toString()?.toLowerCase()
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(false)
  }

  const staticValue = {
    previewText: 'Preview',
    autoSize: 'auto',
    airaListClassName: 'airaList',
    cloneIcon: 'clone',
    applyReasonIcon: 'apply to reasons',
    deleteIcon: 'delete',
    editIcon: 'edit',
    previewIcon: 'preview',
    approveIcon: 'approve',
    pendingApproval: 'pending approval',
    returnIcon: 'rerun',
    failureIcon: 'failure',
    downloadIcon: 'download',
    sendMailIcon: 'send email',
    viewPassCodeIcon: 'view passcode',
    viewIcon: 'view',
    cancelIcon: 'cancel',
    viewLetterIcon: 'view letter',
    abandonIcon: 'abandon',
    markAsEligibleIcon: 'mark as eligible',
  }
  function MenuListHandler(action, menuIcon, menuTitle, className) {
    const userRolesData = useRecoilValue(mappedUserRoles)
    const userRole =
      selectedContract?.isSimpleAdminHidePIIEnabled &&
      userRolesData?.some(
        (roleName) =>
          roleName?.toString()?.toLowerCase() === utils?.roleList?.simpleAdmin
      )
        ? true
        : false

    const imagSizeSet =
      menuTitle?.toString().toLowerCase() === staticValue?.staticValue ||
      menuTitle?.toString()?.toLowerCase() === staticValue?.applyReasonIcon
    return (
      <MenuItem
        className={`moreverticonmenuitem ${className ? className : ''}`}
        data-testid={'ic_moreVertIcon'}
        key={action?.ActionName}
        onClick={() => {
          action.ActionHandler(
            className?.search(staticValue?.airaListClassName) >= 0 ? row : data,
            rowIndex
          )
          handleClose()
        }}
        disabled={
          action?.ActionName?.toString()?.toLowerCase() ===
            staticValue?.downloadIcon && userRole
        }
      >
        <img
          className={'moreoverImaget'}
          src={menuIcon}
          width={
            className?.search(staticValue?.airaListClassName) >= 0
              ? 20
              : menuTitle === staticValue?.previewText
              ? 17
              : staticValue?.autoSize
          }
          height={
            className?.search(staticValue?.airaListClassName) >= 0
              ? 20
              : menuTitle === staticValue?.previewText
              ? 17
              : staticValue?.autoSize
          }
        />
        &nbsp; &nbsp;
        <Typography variant="inherit" className="moreoverText">
          {menuTitle}
        </Typography>
      </MenuItem>
    )
  }
  return (
    <>
      <IconButton
        className="morevert-icon"
        disableRipple
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        disabled={
          (data?.addmode && data?.addmode) ||
          data?.source === utils?.dvlaMismatchStaticData?.Source ||
          data?.isPoundAddress === false ||
          disabled
          // (data?.isCancelReasonReference && data?.isCancelReasonReference)
        }
        // data-testid="morevert-icon"
      >
        <MoreVert />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        TransitionComponent={Fade}
        className={
          data?.userRole?.toString()?.toLowerCase() ===
          utils?.roleList?.inspector
            ? 'viewpasscodeMorevertIcon'
            : className
        }
        // anchorOrigin={{ horizontal: 'right' }}
      >
        {RowActions.map((action) => {
          const listName = action?.ActionName?.toString()?.toLowerCase()
          const listStatus = data?.status?.toString()?.toLowerCase()
          return (
            <div>
              {listName === staticValue?.editIcon
                ? MenuListHandler(
                    action,
                    className?.search(staticValue?.airaListClassName) >= 0
                      ? EditIconAira
                      : EditIcon,
                    action?.ActionName,
                    className
                  )
                : listName === staticValue?.deleteIcon &&
                  (contractType === utils?.contractTypes?.pcnName ||
                    contractType === utils?.contractTypes?.privateLand ||
                    (contractType === utils?.contractTypes?.fpnName &&
                      data?.isKeeperAddress === undefined) ||
                    (contractType === utils?.contractTypes?.fpnName &&
                      data?.isKeeperAddress === false) ||
                    contractType === undefined)
                ? MenuListHandler(
                    action,
                    className?.search(staticValue?.airaListClassName) >= 0
                      ? DeleteAIRA
                      : DeleteIcon,
                    action?.ActionName,
                    className
                  )
                : listName === staticValue?.previewIcon
                ? MenuListHandler(
                    action,
                    PreviewIcon,
                    action?.ActionName,
                    className
                  )
                : listName === staticValue?.approveIcon &&
                  data.isApproveAllowed === true &&
                  listStatus === staticValue?.pendingApproval
                ? MenuListHandler(
                    action,
                    ApproveIcon,
                    action?.ActionName,
                    className
                  )
                : listName === staticValue?.returnIcon &&
                  listStatus === staticValue?.failureIcon
                ? MenuListHandler(
                    action,
                    ReRunIcon,
                    action?.ActionName,
                    className
                  )
                : listName === staticValue?.downloadIcon
                ? MenuListHandler(
                    action,
                    PCNDownloadIcon,
                    action?.ActionName,
                    data?.reservationStatus?.toString()?.toLowerCase() ===
                      'initiated'
                      ? 'disabled Download'
                      : 'enabled Download',
                    className
                  )
                : listName === staticValue?.sendMailIcon
                ? MenuListHandler(
                    action,
                    SendEmailIcon,
                    action?.ActionName,
                    data?.reservationStatus?.toString()?.toLowerCase() ===
                      'initiated'
                      ? 'disabled SendEmail'
                      : 'enabled SendEmail',
                    className
                  )
                : listName === staticValue?.viewPassCodeIcon &&
                  data?.userRole?.toString()?.toLowerCase() ===
                    utils?.roleList?.inspector
                ? MenuListHandler(
                    action,
                    EyePreviewIcon,
                    action?.ActionName,
                    className
                  )
                : listName === staticValue?.cloneIcon
                ? MenuListHandler(
                    action,
                    CloneIcon,
                    action?.ActionName,
                    className
                  )
                : listName === staticValue?.applyReasonIcon
                ? MenuListHandler(
                    action,
                    LibraryAddCheck,
                    action?.ActionName,
                    className
                  )
                : listName === staticValue?.viewIcon
                ? MenuListHandler(
                    action,
                    EyePreviewIcon,
                    action?.ActionName,
                    className
                  )
                : listName === staticValue?.cancelIcon
                ? MenuListHandler(
                    action,
                    CrossCancelIcon,
                    action?.ActionName,
                    className
                  )
                : listName === staticValue?.viewLetterIcon
                ? MenuListHandler(
                    action,
                    ViewEyeBlackIcon,
                    action?.ActionName,
                    className
                  )
                : listName === staticValue?.abandonIcon
                ? MenuListHandler(
                    action,
                    RejectRedIcon,
                    action?.ActionName,
                    `${className || ''} ${action?.className || ''}`.trim()
                  )
                : listName === staticValue?.markAsEligibleIcon
                ? MenuListHandler(
                    action,
                    data?.isEligible ? ThumbDownIcon : ThumbUpIcon,
                    data?.isEligible
                      ? 'Mark as Not Eligible'
                      : 'Mark as Eligible',
                    className
                  )
                : null}
            </div>
          )
        })}
      </Menu>
    </>
  )
}

MoreVertIcon.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  RowActions: PropTypes.arrayOf(PropTypes.object),
  rowIndex: PropTypes.number,
}
MoreVertIcon.defaultProps = {
  data: {},
  RowActions: [],
  rowIndex: null,
}
export default MoreVertIcon
